export default function AboutSection() {
  return (
    <section id="about" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
            了解我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="space-y-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            <p>
              <strong className="text-foreground-900">糖心视频</strong>是一个致力于为影视爱好者提供免费高清观影体验的在线平台。
              我们聚合了包括<strong className="text-foreground-800">西瓜视频免费、免费视频网站91、91在线视频</strong>在内的多平台优质资源，
              涵盖电影大全、电视剧全集、热门综艺、人气动漫和精品纪录片等海量内容。
            </p>
            <p>
              自上线以来，糖心视频始终坚持以用户为中心，通过不断优化的播放技术和智能推荐算法，
              为每一位追剧人打造<strong className="text-foreground-800">在线不缓冲、高清免费</strong>的极致观影体验。
              我们相信好内容应该被更多人看到，优质影视无需付费门槛。
            </p>
            <p>
              无论是想<strong className="text-foreground-800">免费追剧</strong>的上班族、寻找高分电影的影迷，
              还是追新番的动漫爱好者，糖心视频都是你的最佳选择。每日更新的片库、精心编排的专题合集、实时热播榜单，
              让你轻松发现下一部心头好。
            </p>
            <p>
              糖心视频将持续拓展内容边界，优化播放体验，并欢迎优质影视资源的投稿与合作。
              你的每一次观看，都是我们前进的动力。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
              <div className="text-xs text-foreground-500 mt-1">实时同步</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">4K</div>
              <div className="text-xs text-foreground-500 mt-1">超高清画质</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">全免费</div>
              <div className="text-xs text-foreground-500 mt-1">无需会员</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}